"use client";

import { InternalSourceLink } from "@/ui/components/analytics/internal-source-link";
import { useBridgeCtaTracking } from "./use-bridge-cta-tracking";

export function ProductCtaLink({
	calcSlug,
	productSlug,
	locale,
	channel,
	label,
}: {
	calcSlug: string;
	productSlug: string;
	locale: string;
	channel: string;
	label: string;
}) {
	const { setTrackedElement, trackClick } = useBridgeCtaTracking({
		bridge_surface: "spoke_footer",
		locale,
		channel,
		peptide_slug: calcSlug,
		product_slug: productSlug,
		variant_id: null,
		match_type: "none",
		cta_action: "view_product",
	});
	return (
		<InternalSourceLink
			ref={setTrackedElement}
			href={`/${locale}/${channel}/products/${productSlug}`}
			source="calculator"
			detail={calcSlug}
			onClick={trackClick}
			className="hover:bg-primary/90 mt-2 inline-flex min-h-11 items-center gap-2 rounded-lg bg-primary px-4 py-2 text-sm font-medium text-primary-foreground transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
		>
			{label}
		</InternalSourceLink>
	);
}
